<template>
	<div>
		<div class="authPage__text">
			<div class="authPage__title">
				<div class="authPage__titleLine1">
					{{ $t("forgotPasswordTitleLine1") }}
				</div>
				<div class="authPage__titleLine2">
					{{ $t("forgotPasswordTitleLine2") }}
				</div>
			</div>
			<div class="authPage__lead">
				{{
					$t(
						"Não se preocupe, podemos ajudar! Se você ainda se lembra do seu endereço de e-mail, pode redefinir a sua password rápidamente. Preencha o campo abaixo e clique no botão. Isso enviará um novo e-mail que o enviará para a alteração da password."
					)
				}}
			</div>
		</div>

		<ValidationObserver v-slot="{ handleSubmit }">
			<form
				class="authPage__form"
				@submit.prevent="handleSubmit(handleValidSubmit)"
			>
				<div
					:style="{
						'margin-bottom': '60px',
					}"
				>
					<ValidationProvider rules="required|email" v-slot="{ errors }">
						<BFieldBlock :label="$t('E-mail')">
							<BFieldText
								v-model="form.email"
								:placeholder="$t('Insira o e-mail')"
								:state="errors.length ? 'error' : undefined"
								:helperText="errors.length ? $t(errors[0]) : undefined"
							/>
						</BFieldBlock>
					</ValidationProvider>
				</div>

				<div class="o-stack">
					<BBtn>
						{{ $t("Reset password") }}
					</BBtn>
				</div>
			</form>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapActions } from "vuex";

import BBtn from "@/components/base/BBtn";
import BFieldBlock from "@/components/base/BFieldBlock";
import BFieldText from "@/components/base/BFieldText";

import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
	components: {
		BBtn,
		BFieldBlock,
		BFieldText,
		ValidationProvider,
		ValidationObserver,
	},
	props: {
		screen: {
			type: String,
			default: "login",
		},
	},
	data() {
		return {
			form: {
				email: "",
			},
		};
	},
	methods: {
		...mapActions("user", ["requestPasswordReset"]),
		handleValidSubmit(e) {
			this.requestPasswordReset({ email: this.form.email })
				.then(() => {
					this.$notify({
						type: "success",
						title:
							"E-mail enviado com sucesso. Verifique a sua caixa de entrada.",
					});
				})
				.catch((err) => {
					this.$notify({
						type: "error",
						title: "Erro ao enviar e-mail",
					});
				});
		},
	},
};
</script>
